document.addEventListener('DOMContentLoaded', (event) => {
  const inputEmail = document.querySelector('.js-newsletter-email-input')
  const submitEmailButton = document.querySelector('.js-newsletter-submit')

  const emailErrorMessage = document.querySelector('.js-newsletter-error')
  const statusMessageContainer = document.querySelector('.js-newsletter-status')
  const requiredLegend = document.querySelector('#FooterNewsletterRequiredLegend')

  const form = document.querySelector('#footer_newsletter_email')
  const checkbox =
    form?.querySelector('.js-newsletter-tc-input') ??
    form?.querySelector('#footer-newsletter-tc') ??
    form?.querySelector('input[type="checkbox"]')

  let waitingEmailSubmit = false

  const ERROR_ID = 'FooterNewsletterEmailError'
  const LEGEND_ID = 'FooterNewsletterRequiredLegend'

  function setNewsletterA11y({
    errorVisible,
    legendVisible,
    emailInvalid,
    checkboxInvalid,
  }) {
    const emailParts = []
    if (errorVisible && emailInvalid) emailParts.push(ERROR_ID)
    if (legendVisible) emailParts.push(LEGEND_ID)
    if (emailParts.length) inputEmail.setAttribute('aria-describedby', emailParts.join(' '))
    else inputEmail.removeAttribute('aria-describedby')
    inputEmail.setAttribute('aria-invalid', emailInvalid ? 'true' : 'false')

    if (checkbox) {
      const cbParts = []
      if (errorVisible && checkboxInvalid) cbParts.push(ERROR_ID)
      if (legendVisible) cbParts.push(LEGEND_ID)
      if (cbParts.length) checkbox.setAttribute('aria-describedby', cbParts.join(' '))
      else checkbox.removeAttribute('aria-describedby')
      checkbox.setAttribute('aria-invalid', checkboxInvalid ? 'true' : 'false')
    }
  }

  function clearNewsletterError() {
    emailErrorMessage.classList.add('hidden')
    emailErrorMessage.textContent = ''
    requiredLegend?.classList.add('hidden')
    setNewsletterA11y({
      errorVisible: false,
      legendVisible: false,
      emailInvalid: false,
      checkboxInvalid: false,
    })
  }

  function showNewsletterError(message, {
    showLegend,
    emailInvalid,
    checkboxInvalid,
    focusTarget,
  }) {
    requiredLegend?.classList.toggle('hidden', !showLegend)
    emailErrorMessage.classList.remove('hidden')
    emailErrorMessage.textContent = message
    setNewsletterA11y({
      errorVisible: true,
      legendVisible: showLegend,
      emailInvalid,
      checkboxInvalid,
    })
    if (focusTarget === 'checkbox' && checkbox) checkbox.focus()
    else if (focusTarget === 'email') inputEmail.focus()
  }

  clearNewsletterError()

  const displayFormSuccessMessage = () => {
    const tcCheckbox = document.querySelector('#footer-newsletter-tc')

    inputEmail.value = ''
    inputEmail.setAttribute('disabled', '')
    submitEmailButton.classList.add('hidden')
    clearNewsletterError()
    tcCheckbox?.setAttribute('disabled', '')
    statusMessageContainer.innerText = inputEmail.getAttribute(
      'data-confirmation-message'
    )
  }

  async function submitClicked() {
    if (waitingEmailSubmit) return
    clearNewsletterError()
    waitingEmailSubmit = true

    try {
      const response = await fetch('/apps/tools/api/newsletter-signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: inputEmail.value }),
      })

      if (!response.ok) {
        throw new Error('Failed to subscribe to newsletter')
      }

      displayFormSuccessMessage()
    } catch (error) {
      showNewsletterError(window.errorStrings.defaultErrorMessage, {
        showLegend: false,
        emailInvalid: true,
        checkboxInvalid: false,
        focusTarget: 'email',
      })
    } finally {
      waitingEmailSubmit = false
    }
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  submitEmailButton.addEventListener('click', (e) => {
    e.preventDefault()
    if (checkbox && !checkbox.checked && !inputEmail.value) {
      showNewsletterError(window.errorStrings.emptyEmailAndCheckbox, {
        showLegend: true,
        emailInvalid: true,
        checkboxInvalid: true,
        focusTarget: 'email',
      })
    } else if (
      checkbox &&
      !checkbox.checked &&
      !validateEmail(inputEmail.value)
    ) {
      showNewsletterError(window.errorStrings.invalidEmailAndCheckbox, {
        showLegend: false,
        emailInvalid: true,
        checkboxInvalid: true,
        focusTarget: 'email',
      })
    } else if (checkbox && !checkbox.checked) {
      showNewsletterError(window.errorStrings.emptyCheckbox, {
        showLegend: false,
        emailInvalid: false,
        checkboxInvalid: true,
        focusTarget: 'checkbox',
      })
    } else if (!inputEmail.value) {
      showNewsletterError(window.errorStrings.emptyEmail, {
        showLegend: true,
        emailInvalid: true,
        checkboxInvalid: false,
        focusTarget: 'email',
      })
    } else if (!validateEmail(inputEmail.value)) {
      showNewsletterError(window.errorStrings.invalidEmail, {
        showLegend: false,
        emailInvalid: true,
        checkboxInvalid: false,
        focusTarget: 'email',
      })
    } else {
      clearNewsletterError()
      submitClicked('email')
    }
  })
})
